
import React from 'react';

const ContactInfo = () => {
    return(
        <>
        <div className="cont-contact-infos">
        <ul>
            <li>
            <span><i className="fa fa-address-book" /> Address</span>
            <p>765 Shuttle Swift Area <br />at New Born Road </p>
            </li>
            <li>
            <span><i className="fa fa-fax" /> Fax/Email</span>
            <p>674-46-7-0, 234-8-987 <br />hello@email.com</p>
            </li>
        </ul>
        </div>
        </>
    )
}

export default ContactInfo;